// 注册微应用主应用
import { registerMicroApps, start, addGlobalUncaughtErrorHandler, initGlobalState } from 'qiankun';
import apps from "./apps";

// 微应用通信 定义全局状态，并返回通信方法
const state = {}
const actions = initGlobalState(state);
actions.setGlobalState({
	globalToken: ''
})

registerMicroApps(apps, {
    beforeLoad: (app) => {
		console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
        return Promise.resolve();
    },
    afterMount: (app) => {
        console.log("after mount", app.name);
        return Promise.resolve();
    },
});

addGlobalUncaughtErrorHandler((event: any) => {
    console.error(event);
    const { message: msg } = event
    if (msg && msg.includes("died in status LOADING_SOURCE_CODE")) {
        console.error("微应用加载失败，请检查应用是否可运行");
    }
});

export default start;
export {
    actions
}